import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";

import * as translationHelper from "../../../helpers/translationHelper";
import * as windowService from "../../../services/windowService";

import imgLoader from "../../../resources/img/loader.svg";
import imgAddDb from "../../../resources/img/svgicons/databases-add.svg";
import imgFileUpload from "../../../resources/img/svgicons/file-arrow-up.svg";
import Button, {BUTTON_SMALL} from "../../global/generic/Button";

export default class AddDatabasePanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addDatabaseActive: false,
            filePath: null,
            fileName: ""
        };
    }

    componentDidMount = () => {
        let isLocalhost = false;

        if (this.props.activeServer !== null) {
            let localhosts = windowService.getLocalhosts();
            isLocalhost = localhosts.includes(this.props.activeServer.ip);
        }

        this.setState({
            addDatabaseActive: isLocalhost && !windowService.isBrowser()
        });
    };

    changeFilePath = (path) => {
        let parts = path.split("/");

        if (parts.length > 0) {
            this.setState({
                filePath: path,
                fileName: parts.pop()
            });
        }
    };

    handleAddFileClick = () => {
        windowService.openSelectFileDialog(
            "/",
            this.changeFilePath,
            windowService.isWindows() ? ["zip", "exe"] : ["zip"]
        );
    };

    handleInstallClick = () => {
        if (this.state.fileName !== "") {
            if (this.state.fileName.toLowerCase().includes(".exe")) {
                this.props.installDatabaseExe(this.state.filePath);
            }
            if (this.state.fileName.toLowerCase().includes(".zip")) {
                this.props.installDatabaseZip(this.state.filePath);
            }
        }
    };

    handleDatabaseFromExcelClick = () => {
        this.props.openDatabaseFromExcelModal();
    };

    getDbStatus = (key, db) => {
        return (
            <tr key={key} className="server-row">
                <td>
                    <div>{db.name}</div>
                </td>
                <td>
                    <div>{translationHelper.getDbStatusTranslation(db.status)}</div>
                </td>
            </tr>
        );
    };

    getDatabaseStatuses = () => {
        if (this.props.databaseList.length === 0) {
            return (
                <tr className="server-row">
                    <td>
                        <div>
                            <Translate value="welcome.availableDatabase" />
                        </div>
                    </td>
                    <td>
                        <div></div>
                    </td>
                </tr>
            );
        }

        let statusList = [];
        let key = 0;

        for (let db of this.props.databaseList) {
            if (db !== null) {
                statusList.push(this.getDbStatus(key, db));
                key++;
            }
        }

        return statusList;
    };

    getInstallButton = () => {
        if (this.state.filePath === null) {
            return "";
        }

        return <Button size={BUTTON_SMALL} onClick={this.handleInstallClick} label={translate("general.install")} />;
    };

    getDatabaseTable = () => {
        if (this.props.loading) {
            return (
                <div className="slim-scroll col-xs-12 server-table">
                    <div>
                        <div className="col-xs-12 update-warning server-row">
                            <Translate value="welcome.updatingWarning" />
                        </div>
                        <div className="col-xs-12 update-warning-info server-row">
                            <Translate value="welcome.updatingWarningInfo" />
                        </div>
                        <div className="col-xs-12">
                            <img alt="loader" src={imgLoader} className="loader" />
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="slim-scroll col-xs-12 server-table">
                <table>
                    <thead>
                        <tr>
                            <th className="color-primary">
                                <Translate value="general.database" />
                            </th>
                            <th className="color-primary">
                                <Translate value="general.note" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>{this.getDatabaseStatuses()}</tbody>
                </table>
            </div>
        );
    };

    getAddDatabaseForm = () => {
        if (!this.state.addDatabaseActive || this.props.loading) {
            return "";
        }

        return (
            <div className="add-db-row">
                <div className="col-xs-12">
                    <div className="color-primary">
                        <Translate value="addDatabase.addDatabase" />:
                    </div>
                    <div className="col-xs-9 flex flex-gap-5px">
                        <Button
                            size={BUTTON_SMALL}
                            svgBefore={imgFileUpload}
                            label={translate("addDatabase.createFromExcel")}
                            onClick={this.handleDatabaseFromExcelClick}
                        />
                        <Button
                            size={BUTTON_SMALL}
                            svgBefore={imgAddDb}
                            label={translate("addDatabase.addFromFile")}
                            onClick={this.handleAddFileClick}
                        />
                        {this.getInstallButton()}
                    </div>
                </div>
                <div className="col-xs-12">
                    <span className="color-primary">{this.state.fileName}</span>
                </div>
            </div>
        );
    };

    render() {
        return (
            <React.Fragment>
                <div className="col-xs-12 select-server-text">
                    <Translate value="navigation.menu.availableDatabases" />
                </div>
                {this.getDatabaseTable()}
                {this.getAddDatabaseForm()}
            </React.Fragment>
        );
    }
}
